import { Model, Serializer, createServer } from "miragejs";
import {
  groupReservation,
  groupTripReceipt,
  vehicle1,
  vehicle2,
  vehicle3,
  reservationReciept,
  mirageWalletTransactions,
} from "./mirageData";

// README:
// This is a MirageJS server file that will allow us to easily mock
// API endpoints while they are still under development.
// Once the API is in place, please comment out/remove your mocks and
// passthrough() the route.
// NOTE: This file is only in effect when environment = development
const ApplicationSerializer = Serializer.extend({
  root: false,
  embed: true,
});

export function makeServer({ environment = "development" } = {}) {
  createServer({
    environment,

    // PLEASE COMMENT OUT RATHER THAN DELETING UNUSED MOCKS
    models: {
      customer: Model,
      reservation: Model,
      group_reservation: Model,
    },

    serializers: {
      application: ApplicationSerializer,
    },

    seeds(server) {
      server.create("customer", {
        balance: {
          real: 370,
          bonus: 0,
          total: 370,
        },
        currency: "USD",
        was_card_attached: true,
        auto_renew_enabled: false,
        auto_renew_option: {
          id: "e13353c9-fa7b-4122-bf28-670c19fbe28f",
          amount: 1500,
          bonus: 200,
          rate_plan_id: "678de7f3-4cbb-47af-8a9a-7c04e861eaef",
        },
      });
      server.create("reservation", {
        created: "2020-07-09 16:22:30.614316",
        trip_date: "2020-07-09T16:22:30.614316Z",
        fee_type: "time",
        payments: [
          {
            amount: 970,
            created: "2020-07-09 16:22:30.625482",
            payment_date: "2020-07-09T16:22:30.625482Z",
            status: "succeeded",
            payment_method: null,
          },
        ],
        rate_plan: {
          id: "678de7f3-4cbb-47af-8a9a-7c04e861eaef",
          currency: "USD",
          flat_fee: 100,
          time_unit_fee: 30,
          distance_unit_fee: 0,
        },
        duration: 1740,
        distance: null,
        shortcode: `${window.REACT_APP_VEHICLE_API_URL}/short-codes/772`,
        vehicle: `${window.REACT_APP_VEHICLE_API_URL}/vehicles/unique-veh-id-1`,
        vehicle_shortcode: 772,
        amount: 970,
        bonus_amount: 0,
        total_amount: 970,
        payment_date: "2020-07-09 17:24:05.451398",
        last_payment_date: "2020-07-09T17:24:05.451398Z",
        coupons: [],
        trip_estimate_cost: 970,
        discount_amount: 0,
      });
      server.create("group_reservation", {
        created: "2020-07-09 16:22:30.614316",
        trip_date: "2020-07-09T16:22:30.614316Z",
      });
    },

    /* eslint-disable no-unused-vars */
    routes() {
      this.post(
        "proxy/registration/register",
        () => ({
          successes: ["regSuccess1", "regSuccess2"],
          fails: {
            failFin1: "failReason1",
            failFin2: "failReason2",
          },
        }),
        { timing: 3000 },
      );

      this.post("proxy/registration/vehicle-auth-register", () => ({
        successes: ["authSuccess1", "authSuccess2"],
        fails: {
          authFailFin1: "authFailReason1",
          authFailFin2: "authFailReason2",
        },
      }));

      this.post("proxy/registration/manifest", () => ({
        successes: {
          101011934600598: [],
          101012010800195: [],
        },
        fails: {
          101011900000001: "some error",
          101012011111112: "some error",
        },
      }));

      // Get vehicle 1
      this.get(
        `${window.REACT_APP_VEHICLE_API_URL}/vehicles/0d1daa3f-e8b0-4be7-bfd6-1a42b92d56cc`,
        () => vehicle1,
      );

      // Get vehicle 2
      this.get(
        `${window.REACT_APP_VEHICLE_API_URL}/vehicles/01efb699-0fb0-44fd-a400-3480194e2a54`,
        () => vehicle2,
      );

      // Get vehicle 3
      this.get(
        `${window.REACT_APP_VEHICLE_API_URL}/vehicles/32edd2ec-ccc1-46ce-b939-e7a140660fb8`,
        () => vehicle3,
      );

      // get group reservations
      this.get(
        `${window.REACT_APP_RESERVATION_API_URL}/group-reservations/some-group-id`,
        () => groupReservation,
      );

      // get receipt of group host reservation
      this.get(
        `${window.REACT_APP_PROXY_BILLING_URL}/reservations/some-group-id/receipt`,
        () => groupTripReceipt,
      );

      this.get(
        `${window.REACT_APP_PROXY_BILLING_URL}/reservations/test-res/receipt`,
        () => reservationReciept,
      );

      this.get(
        `${window.REACT_APP_PROXY_BILLING_URL}/customers/some-rider-id/transactions`,
        () => mirageWalletTransactions,
      );

      this.urlPrefix = "/proxy";
      this.passthrough();
      this.urlPrefix = window.REACT_APP_PROXY_BILLING_URL;
      this.passthrough();
      this.urlPrefix = window.REACT_APP_AUTH_URL;
      this.passthrough();
      this.urlPrefix = window.REACT_APP_VEHICLE_API_URL;
      this.passthrough();
      this.urlPrefix = window.REACT_APP_CONSUMER_AUTH_URL;
      this.passthrough();
      this.urlPrefix = window.REACT_APP_RESERVATION_API_URL;
      this.passthrough();
      this.urlPrefix = window.REACT_APP_GEOCODING_URL;
      this.passthrough();
      this.urlPrefix = window.REACT_APP_GEOFENCE_API_URL;
      this.passthrough();
    },
  });
}
